import ComponentHeader from '../ComponentHeader';
import StyledWrapper from '../style';

import { getElementIcon } from '../../../FormBuilder/utils';
import { FormControl, TextField, FormHelperText } from '@mui/material';
import FormBuilderStyledWrapper from '../../../FormBuilder/customComponents/style';

const Image = (props) => {
	const style = props.data.center ? { textAlign: 'center' } : null;

	let baseClasses = 'SortableItem rfb-item';
	if (props.data.pageBreakBefore) {
		baseClasses += ' alwaysbreak';
	}

	let fieldName = props.data.field_name;
	let isFormBuilder = props.index >= 0;

	return (
		<div name={fieldName} style={{ ...props.style, ...style }} className={baseClasses}>
			<ComponentHeader {...props} />
			<FormControl sx={{ width: '100%' }} variant="outlined">
				<FormBuilderStyledWrapper.CustomLabel shrink={true} disabled={props.read_only}>
					{props.data?.label}
					{isFormBuilder && (
						<div>
							{props.data?.unique_identifier
								? `(ff-${props.data?.unique_identifier})`
								: `(tmp-${props.data?.temp_order})`}
						</div>
					)}
				</FormBuilderStyledWrapper.CustomLabel>
				<StyledWrapper.BorderOutline
					isCentered={props.data.center}
					isFormBuilder={isFormBuilder}
					src={props.data.src}
					disabled={props.read_only ? true : false}
				>
					{!props.data.src &&
						(isFormBuilder ? (
							<FormControl sx={{ width: '100%' }} variant="outlined">
								<StyledWrapper.CustomLabel
									value={props.data.src}
									disabled={props.read_only ? true : false}
									marginTop="1rem"
								>
									No Image
								</StyledWrapper.CustomLabel>
								<TextField
									disabled={true}
									style={{ width: '100%' }}
									multiline
									InputLabelProps={{ shrink: true }}
								/>
							</FormControl>
						) : (
							<StyledWrapper.CustomLabel
								value={props.data.src}
								disabled={props.read_only ? true : false}
								required={props?.data?.required}
								marginBottom="0"
								marginTop="2rem"
							>
								{isFormBuilder && getElementIcon(props.data?.key)}
								No Image
							</StyledWrapper.CustomLabel>
						))}

					{props.data.src && (
						<img src={props.data.src} width={props.data.width} height={props.data.height} />
					)}
				</StyledWrapper.BorderOutline>
			</FormControl>

			<FormHelperText error={props?.data?.error}>{props?.data?.help_message}</FormHelperText>
		</div>
	);
};

export default Image;
